module.exports = "https://cdn.thelire.com/ins/resource/lh_toast_success.03607b0cff78450f527026b08292d261.png";